import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";

// Uses a location-specific verified project image (card_image) with the stored
// locality image as fallback, and a branded placeholder if neither is available.
export default function LocationCard({ location, index = 0 }) {
  const l = location;
  const src = l.card_image || l.image || null;
  const [broken, setBroken] = useState(false);
  const showImg = src && !broken;

  return (
    <Link
      to={`/locations/${l.slug}`}
      data-testid={`location-card-${l.slug}`}
      className="group relative block h-64 rounded-md overflow-hidden bg-muted"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      {showImg ? (
        <img src={src} alt={`Property in ${l.name}, Pune`} loading="lazy" referrerPolicy="no-referrer"
          onError={() => setBroken(true)}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-primary to-[#122a22]" data-testid={`location-fallback-${l.slug}`}>
          <MapPin className="h-7 w-7 text-accent" aria-hidden />
          <span className="text-white/60 text-xs uppercase tracking-wider">Endeavour Castle</span>
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-5 flex items-end justify-between">
        <div>
          <h3 className="font-display text-2xl text-white">{l.name}</h3>
          <p className="text-sm text-white/80">Pune</p>
        </div>
        <span className="h-9 w-9 rounded-full bg-white/15 backdrop-blur flex items-center justify-center border border-white/30 group-hover:bg-accent group-hover:border-accent transition-colors">
          <ArrowUpRight className="h-4 w-4 text-white" aria-hidden />
        </span>
      </div>
    </Link>
  );
}
